import React from "react";

import { FormattedDate, FormattedTime } from "react-intl";

import Typography from "@material-ui/core/Typography";

import { useQuery } from "@apollo/client";

// import moment from "moment";

import stationInfoQuery from "./station-info-query";

interface Props {
  nodes?: any[];
  panelCollectionName: string;
  // panelId?: string;
  // panelName: String;
  panelDefinition: any;
}

function StationInfo(props: Props) {
  const {
    nodes,
    panelCollectionName,
    // panelId,
    // panelName,
    panelDefinition,
  } = props;
  const n = nodes ? nodes.join(",") : undefined;
  console.log("panelDefinition", panelDefinition);

  const { data, error, loading } = useQuery(stationInfoQuery, {
    variables: {
      panelCollectionName: panelCollectionName,
      panelName: panelDefinition?.template,
      tab: panelDefinition?.id,
      node: n,
    },
  });
  // console.log("cell meta", metaData);
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error.message);
    return <div>Error! {error.message}</div>;
  }
  // FIXME localize lastUpdate (cf. template.jsp)
  // TODO Tooltip (cf. template.jsp)!
  return (
    <>
      <Typography variant="h5">{data.stationInfo?.stationString}</Typography>
      {data.stationInfo?.lastUpdate && (
        <Typography variant="subtitle2">
          <FormattedDate
            value={data.stationInfo.lastUpdate}
            year="numeric"
            month="2-digit"
            day="2-digit"
          />
          &nbsp;
          <FormattedTime value={data.stationInfo.lastUpdate} />
        </Typography>
      )}
    </>
  );
}

export default StationInfo;
